//client/src/components/accounts/Logout.js

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Typography } from '@mui/material';
import { useAuth } from "../../contexts/AuthContext";

const LogoutPage = () => {

  const { logout, setError } = useAuth();
  const navigate = useNavigate();

  async function handleLogout() {
    try {
      setError("");
      await logout();
      navigate("/");
    } catch {
      setError("Failed to logout");
    }
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100vh' }}>
      <Typography variant="h4" gutterBottom>
        Are you sure you want to log out?
      </Typography>
      <Button variant="contained" color="primary" onClick={handleLogout}>
        Log Out
      </Button>
    </div>
  );
};

export default LogoutPage;
